import { mergeClassnames } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  position?: number;
  username?: string;
  color?: string;
  isMyScore?: boolean;
};

const Username: React.FC<Props> = ({
  username,
  position,
  color,
  isMyScore,
}) => (
  <>
    {username && (
      <span
        style={{ color }}
        className={mergeClassnames(
          'm-0 place-self-center justify-self-start text-moon-12 text-bulma',
          isMyScore && 'font-medium',
        )}
      >
        {username}
      </span>
    )}
    {!username && (
      <span
        style={{ color }}
        className={mergeClassnames(
          'm-0 place-self-center justify-self-start text-moon-12 text-bulma',
          isMyScore && 'font-medium',
        )}
      >
        {position} <Translate id="game-leaderboard.position" />
      </span>
    )}
  </>
);

export default Username;
